export default {
  dashboard: {
    promoCode: "Promo Code",
    users: "Users",
    pharmacy: "Pharmacies",
    searchByDoctorPlaceholder: "Search by name, email, phone number",
    searchByClinicPlaceholder: "Search by name, email, phone number, city",
    searchByStatePlaceholder: "Search by state",
    doctor: "Doctors",
    details: "Details",
    metrics: "Metrics",
    clinic: "Clinics",
    lab: "Labs",
    labDetails: "Lab Details",
    pharmacyDetails: "Pharmacy Details",
    title: "Dashboard",
    no: "No.",
    time: "Time",
    patient_info: "Patient Info",
    type: "Type",
    urgency: "Urgency",
    assigned_to: "Assigned to",
    status: "Status",
    yrs: "Years",
    yes: "Yes",
    new: "New",
    closed: "Closed",
    escalated: "Escalated",
    processing: "Processing",
    new_ticket_created: "New ticket has been raised, check it out !!",
    new_ticket_assignment: "New ticket has been assigned, check it out !!",
    on_call: "ON CALL",
    patient_app: "PATIENT APP",
    all: "All",
    filterBy: "Filter by:",
    typeToSearch: "Type to search by name, phone no., ticket no.",
    appointment: "Appointment",
    booked: "Booked",
    notBooked: "Not booked",
    websites: "Websites",
    domains: "Domains",
    searchBy: "Search by:",
    searchByPlaceholder: "Search by name or phone number",
    searchByPhoneNumber: "Search by phone number",
    clinicId: "Clinic id",
    domainDetail: "Domain details",
    viewDetail: "View detail"
  },
  info_title: "Info",
  success_title: "Success!",
  error_title: "Error!",
  userAccounts: "User Accounts",
  userDetails: "User Details",
  userSubscription: "Active Plans",
  billingDetail: "Invoice History",
  adminAccess: "You need admin access to sign in",
  connecting_chat: "Connecting to chat",
  connecting_chat_failed: "Connection to chat failed",
  selectCoordinator: "Select coordinator",
  searchConversations: "Search conversation",
  send: "Send",
  newChatMessage: "New message!",
  chatMessageDescription: "You have received a new message.",
  ticket: { created_ticket: "created ticket" },
  topNav: { sign_out: "Sign out" },
  tickets: {
    add_ticket: "Add Ticket",
    patient_name: "Patient Name",
    error_patient_name: "Provide the patient's name.",
    patient_dob: "Patient Dob",
    gender: "Gender",
    health_problem: "Health problem",
    error_health_problem: "Provide the Health problem.",
    phone_number: "Phone Number",
    error_phone_number: "Provide the valid patient's phone number.",
    location: "Location",
    error_location: "Provide the location",
    price_from: "Price range - From",
    price_to: "Price range - To",
    error_price_from: "Provide the start price range.",
    error_price_to: "Provide the end price range.",
    urgency: "Urgency",
    assigned_to: "Assigned to",
    error_assigned_to: "Select the assignee.",
    close: "Close",
    add: "Add",
    urgent: "Urgent",
    not_urgent: "Not Urgent",
    male: "Male",
    female: "Female",
    edit_ticket: "Edit Ticket"
  },
  ok: "OK",
  clinic: {
    phone: "Mobile Number",
    email: "Email",
    name: "Clinic Name",
    area: "Area (locality)",
    about: "About",
    address: "Address",
    pincode: "Pincode",
    city: "City",
    speciality: "Clinic speciality"
  },
  ticket_detail_view: {
    ticket_details: "Ticket details",
    info: "Info",
    activity: "Activity",
    search: "Search",
    health_problem: "Health Problem",
    location: "Location",
    fee_range: "Fee Range",
    open_since: "Open since",
    assigned_to: "assigned to",
    status: "Status",
    select_agent: "Select Agent",
    select_status: "Status Status",
    yrs: "Yrs",
    edit: "Edit",
    not_signed_up: "Not Signed Up",
    signed_up: "Signed Up",
    previous_tickets: "Previous Tickets",
    fees: "Fees",
    select_range: "Select Range",
    select_speciality: "Select Speciality",
    speciality: "Speciality",
    availability: "Availability",
    dr_info: "Dr. Info",
    timings: "Timings",
    latest_available: "Latest Availabile",
    no_data: "No data",
    send_to_app: "Send to App",
    send_sms: "Send Sms",
    escalated_to: "Escalated to",
    added_note: "added a note",
    add_note: "Add a note",
    emptyNoteError: "Note cannot be empty.",
    save: "Save",
    saveSuccess: "Ticket saved successfully !!",
    success: "Success",
    ok: "Ok",
    sendMessageSuccess:
      "Message has been sent to {selectedDoctorNameArr} successfully!!",
    sendMessageError: "Please select a doctor for sending message to.",
    selectLocation: "Select location",
    regularTimings: "Regular timings",
    discountedTimings: "Discounted timings",
    book: "Book",
    errorText: "There was some problem while processing your request.",
    bookingSuccess: "Appointment booked successfully.",
    bookAppointment: "Book Appointment",
    bookAppointmentConfirmText:
      "Are you sure you want to book appointment in this slot?",
    bookAppointmentText:
      "booked a regular appointment with {doctorName} for {appointmentDate}",
    bookDiscountedAppointmentText:
      "booked a discounted appointment with {doctorName} for {appointmentDate} between {startTime} - {endTime}",
    reBookAppointmentText:
      "re-booked a regular appointment with {doctorName} for {appointmentDate}",
    reBookDiscountedAppointmentText:
      "re-booked a discounted appointment with {doctorName} for {appointmentDate} between {startTime} - {endTime}",
    dr: "Dr.",
    changesStatus: "changes status to",
    date: "Date:",
    TimeSlot: "Time slot:",
    BookedOn: "Booked on:",
    doctor: "Doctor:",
    Contact: "Contact:",
    Clinic: "Clinic:",
    AppointmentDetails: "Appointment details",
    unverifyTitle: "Would you like to verify doctor",
    VerifyDoctor: "Verify doctor",
    UnverifyDoctor: "Unverify doctor",
    verifyReason: "Please mention the verification reason.",
    unverifyReason: "Would you like to Unverify doctor ?",
    MedicalLicense: "Medical license",
    ClickToView: "Click to view",
    VerifyStatus: "Verify status",
    VerifiedBy: "Verified by",
    VerifiedAt: "Verified At",
    VerifyReason: "Verify reason",
    Select: "Select",
    CheckedWithCollege: "Checked with College",
    CheckedWithIMA: "Checked with IMA",
    DoctorVerified: "Doctor verified successfully",
    DoctorUnverified: "Doctor unverified successfully",
    DoctorVerification: "Doctor verification",
    PleaseReason: "Please select a reason",
    ToProvide: "To verify please provide",
    MedicalLicenseNumber: "Medical license number and photo",
    Unverify: "Unverify",
    Verified: "Verified",
    NotVerified: "Not Verified",
    Unverify: "Unverify",
    Verify: "Verify",
    chat: "Chat"
  },
  page_not_found: {
    pageNotFound: "Page not found"
  },
  referrals: {
    referralsText: "Referrals",
    referredTo: "Referred to",
    referredBy: "Referred by",
    appointmentStatus: "Status",
    addToQueue: "Add to queue",
    viewNotes: "View notes",
    selectDateForAppt: "Select appointment date",
    referralNotes: "Referral notes",
    noReferralNotes: "No referral notes added by doctor",
    newReferralRecieved: "New referral recieved",
    serialNo: "S.no",
    patient: "Patient"
  },
  month: "Months",
  year: "Years",
  schedule: {
    updateSchedule: "Update Schedule",
    addSchedule: "Add Schedule",
    daily: "Daily",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun",
    startTime: "Start Time",
    closingTime: "Closing Time",
    discounted_schedule: "Discounted Timings",
    regular_schedule: "Regular Timings",
    fees: "Fees",
    cancel: "Cancel",
    emptyDays: "Please select days",
    emptyTimings: "Please select timings",
    invalidTiming: "Please select valid timings",
    emptyFeesError: "Please enter fee amount",
    scheduleInfo: "Schedule Info",
    scheduleText: "Schedule",
    addedSuccess: "added successfully",
    serverError: "There was some error while processing your request",
    remove: "Remove",
    removed: "removed successfully",
    days: "days",
    timings: "Timings",
    removeScheduleConfirmText: "Are you sure you want to remove this schedule?",
    updateDoctor: "Update Fees info",
    updateDoctorSuccess: "Fees info updated successfully",
    updateFees: "Update Fees",
    Next: "Next",
    edit: "Edit",
    delete: "Delete",
    save: "Saver"
  },
  profile: {
    inbox: "Inbox",
    clinicName: "Clinic Name",
    emptyText: "cannot be empty",
    addressText: "Address",
    zipcode: "Pincode",
    city: "City",
    selectLocationError: "Please select the city from dropdown",
    SearchPlaces: "Search Places",
    state: "State",
    basicInfoSaveSuccess: "Profile saved successfully",
    doctorName: "Doctor name",
    isRequired: "is required",
    dateOfBirth: "Date of birth",
    registrationNumber: "Registration number",
    patientsPerHour: "Patients per hour",
    experience: "Experience (in years)",
    bio: "Bio",
    next: "Next",
    updateEducationSuccess: "Education updated successfully",
    error: "Error",
    educationExists: "Education already exists",
    deleteEducationSuccess: "Education deleted successfully",
    educationName: "Education name",
    action: "action",
    clinicProfile: "Clinic profile",
    clinicSaveSuccess: "Clinic profile saved successfully",
    doctors: "Doctors",
    educationSaveSuccess: "Education saved successfully",
    verify: "verify"
  },
  signin: {
    signInHeadingText: "Please sign in with your phone number and password",
    enterPhoneNumber: "Please enter phone number",
    passwordRequired: "Please enter the password.",
    password: "Password",
    signInText: "Sign in"
  },
  domain: {
    dateTime: "Date & Time",
    result: "result",
    results: "results",
    markDone: "Mark as done",
    all: "All",
    new: "New",
    done: "Done",
    delete: "Delete",
    update: "Update",
    complete: "Complete",
    updateUrl: "Update Status",
    confirm: "Confirm",
    cancel: "Cancel",
    enterUrl: "Example: https://www.google.com",
    enterValidUrl: "Enter valid url",
    domain: "Domains",
    domainName: "Name",
    status: "Status",
    filterByType: "Filter by type:",
    filterByStatus: "Filter by status:",
    requestedAt: "Requested At",
    completedAt: "Completed At"
  },
  website: {
    websiteDetail: "Clinic Detail",
    clininInfo: "Basic Info",
    photos: "Photos",
    doctors: "Doctors",
    services: "Services",
    packages: "Packages",
    reviews: "Kulcare Reviews",
    seo: "Website Info"
  },
  seo: {
    seoTitle: "Title",
    seoDescription: "meta description",
    googleCode: "Google Analytics account code",
    themeUrl: "Theme Url",
    themeName: "Theme Name"
  },
  services: {
    serviceId: "Id"
  },
  packages: {
    description: "Description",
    new_price: "New Price",
    valid_till: "Valid Till",
    photo: "Photo",
    old_price: "Old Price"
  },
  doctor: {
    name: "Name",
    speciality: "Speciality",
    eductaion: "Main Education",
    experience: "Years of experience",
    patientPerHour: "Patients per hour",
    medicalRegisterNumber: "Medical reg. number",
    fees: "Fees",
    gender: "Gender",
    schedule: "Schedule",
    other: "Other",
    photoUrl: "Photo Url",
    startTime: "Start Time",
    endTime: "End Time"
  },
  photo: {
    type: "Type",
    link: "Link",
    download: "Download"
  },
  reviews: {
    created: "Created",
    review: "Review",
    rating: "Rating"
  },

  phone_and_password_required: "Phone number and password are required.",
  invalid_valid_phone_number: "Enter valid phone number.",
  short_pwd_error: "Password is too short.",
  invalid_password: "Password is invalid.",
  invalid_username_pwd: "Phone Number or Password is invalid.",
  error_msg: "There was some error while processing the request.",
  results: "Results",
  result: "Result",
  typeToSeachByName: "Type name press enter",
  searchByName: "Search by name",
  radiusPlaceholder: "Radius",
  radius: "Radius(in Km)",
  go_home: "Go home",
  viewDetail: "View Details",
  back: "back"
};
